import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPhone = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_138_7799)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 1.83496C6.25736 1.83496 5.25 2.84232 5.25 4.08496V20.585C5.25 21.8276 6.25736 22.835 7.5 22.835H16.5C17.7426 22.835 18.75 21.8276 18.75 20.585V4.08496C18.75 2.84232 17.7426 1.83496 16.5 1.83496H7.5ZM17.25 3.33496H6.75V21.335H17.25V3.33496Z",
			fill: "white"
		}), /* @__PURE__ */ _jsx("rect", {
			x: 9.75,
			y: 4.08496,
			width: 4.5,
			height: 1.5,
			rx: .75,
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_138_7799",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white",
			transform: "translate(0 0.334961)"
		})
	}) })]
});
export default SvgPhone;
